import CloseIcon from "@mui/icons-material/Close";
import {
  Card,
  CardContent,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Skeleton,
  Stack,
} from "@mui/material";
import { useSession } from "@src/appV2/Auth/api/useSession";
import { type UseModalState } from "@src/lib/ui-react";

import { transformResponseIntoPlacement } from "../api/useFetchPaginatedPlacements";
import { useGetPlacement } from "../api/useGetPlacement";
import { PlacementDetails } from "./PlacementDetails";

interface PlacementDialogProps {
  modalState: UseModalState;
  placementId: string;
}

export function PlacementDialog(props: PlacementDialogProps) {
  const { modalState, placementId } = props;
  const { profile } = useSession();
  const {
    data: rawPlacementResponse,
    isLoading: isLoadingPlacement,
    isSuccess: isPlacementSuccess,
  } = useGetPlacement({
    placementId,
    workplaceId: profile.userId,
  });
  const placement = isPlacementSuccess
    ? transformResponseIntoPlacement(rawPlacementResponse.data, rawPlacementResponse.included)
    : undefined;

  return (
    <Dialog
      fullWidth
      open={modalState.modalIsOpen}
      maxWidth="lg"
      scroll="paper"
      onClose={modalState.closeModal}
    >
      <DialogTitle>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          Listing details
          <IconButton aria-label="close" onClick={modalState.closeModal}>
            <CloseIcon />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent dividers>
        {isLoadingPlacement && <Skeleton variant="rounded" height={200} />}
        {placement && (
          <Card sx={{ width: "100%" }} variant="outlined">
            <CardContent
              sx={{
                "&:last-child": {
                  paddingBottom: 2,
                },
              }}
            >
              <PlacementDetails placement={placement} />
            </CardContent>
          </Card>
        )}
      </DialogContent>
    </Dialog>
  );
}
